import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * @test-file: Footer.test.tsx
 * @test-coverage: 9 tests (current year, copyright, heart emoji, className, dynamic year updates)
 * @last-updated: 2025-12-28
 */
/**
 * Footer component - Standard application footer
 * Displays copyright year and branding
 *
 * @example
 * ```tsx
 * import { Footer } from '@shared/ui-react';
 *
 * function App() {
 *   return (
 *     <div>
 *       <main>Content here</main>
 *       <Footer />
 *     </div>
 *   );
 * }
 * ```
 */
export function Footer() {
    const year = new Date().getFullYear();
    return (_jsx("footer", { className: "footer", children: _jsxs("div", { className: "footer-line", children: [_jsx("span", { children: year }), "\u00A0made with ", _jsx("span", { className: "heart", children: "\u2764\uFE0F" }), " \u2013 \u00A9 weretradeIT"] }) }));
}
;
